import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiateCryptocurrencyTransferRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { InitiateCryptocurrencyTransferResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const initiateCryptocurrencyTransfer = (
  request: InitiateCryptocurrencyTransferRequest,
  options?: CashRequestOptions
) =>
  post<InitiateCryptocurrencyTransferRequest, InitiateCryptocurrencyTransferResponse>(
    '/2.0/cash/initiate-cryptocurrency-transfer',
    request,
    { ...options, rejectOnError: true }
  )
